'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var env = 'production' || 'development';
exports.default = {
  // 超时时长
  DEFAULT_TIMEOUT_LIMIT: 5000,
  // 默认循环次数
  DEFAULT_INTERVAL_TIMES: 5,
  // 卖座域名
  MZ_HOST: 'm.maizuo.com',
  // 苏打优选域名
  SDYX_HOST: env === 'preview' ? 'pre-m.sdyxmall.com' : 'm.sdyxmall.com',
  // iOS bridge name
  IOS_BRIDGE_NAME: 'WebViewJavascriptBridge',
  // android bridge name
  ANDROID_BRIDGE_NAME: 'AndroidMallBridge',
  // iOS bridge ready event
  IOS_BRIDGE_READY_EVENT: 'WebViewJavascriptBridgeReady',
  // android bridge ready event
  ANDROID_BRIDGE_READY_EVENT: 'AndroidMallBridgeReady',
  // ios WebViewJavascriptCallbacks
  IOS_BRIDGE_CALLBACKS: 'WVJBCallbacks',
  // ios bridge loaded address
  IOS_BRIDGE_LOADED_ADDRESS: 'wvjbscheme://__BRIDGE_LOADED__',
  //
  DEFAULT_CALLHANDLER_NAME: 'MallBindJs',
  //电影专区地址
  SDYXMALL_MOVIE_HOST: env === 'development' ? 'http://m.sdyxmall.com/movie2/' : env === 'preview' ? 'http://pre-m.sdyxmall.com/movie2/' : 'https://m.sdyxmall.com/movie2/',
  //搜索企业专区商品
  SEARCH_TYPE_IS_ENTERPRISE: 1,
  //苏打优选H5地址
  SDYXMALL_H5_HOST: env === 'development' ? 'http://m.sdyxmall.com/v1/' : env === 'preview' ? 'http://pre-m.sdyxmall.com/v1/' : 'https://m.sdyxmall.com/v1/',
  //登录页面地址
  SDYXMALL_AUTH_LOGIN_PAGE_URL: window.location.protocol + "//" + window.location.hostname + '/auth/#/connect/login',
  //苏打优选act地址
  SDYXMALL_ACT_HOST: env === 'development' ? 'http://m.sdyxmall.com/act/' : env === 'preview' ? 'http://pre-m.sdyxmall.com/act/' : 'https://m.sdyxmall.com/act/',

  //卖座APP电影专区地址
  MAIZUO_MOVIE_HOST: env === 'development' ? 'http://m.maizuo.com/v5/' : env === 'preview' ? 'http://m.maizuo.com/v5/' : 'https://m.maizuo.com/v5/',
  //卖座APPH5地址
  MAIZUO_H5_HOST: env === 'development' ? 'http://m.maizuo.com/v5/' : env === 'preview' ? 'http://m.maizuo.com/v5/' : 'https://m.maizuo.com/v5/',
  //卖座APP登录页面地址
  MAIZUO_AUTH_LOGIN_PAGE_URL: window.location.protocol + "//" + window.location.hostname + '/mz-auth/#/connect/login',
  //卖座APP act地址
  MAIZUO_ACT_HOST: env === 'development' ? 'http://m.maizuo.com/mz-act/' : env === 'preview' ? 'http://m.maizuo.com/mz-act/' : 'https://m.maizuo.com/mz-act/'
};